import { IDongBoPhiKyTucXaSinhVien } from "../../../model/respone/dong-bo/IDongBoPhiKyTucXaSinhVien";
import { IDongBoPhiKyTucXaActionTypes } from "../../action-types/dong-bo/IDongBoPhiKyTucXaAction";
import { IdongBoPhiKyTucXaReducer } from "../../reducer-model/dong-bo/IDongBoPhiKyTucXaReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

const iniState: IdongBoPhiKyTucXaReducer = {
  sinhViens: [],
  status: eReducerStatusBase.is_not_initialization,
  idSelections: [],
} as IdongBoPhiKyTucXaReducer;

export const dongBoPhiKyTucXaReducer = (
  state: IdongBoPhiKyTucXaReducer = iniState,
  action: IDongBoPhiKyTucXaActionTypes
): IdongBoPhiKyTucXaReducer => {
  switch (action.type) {
    case "DONG_BO_PHI_KY_TUC_XA_LOAD_START":
      return {
        ...state,
        sinhViens: [] as IDongBoPhiKyTucXaSinhVien[],
        status: eReducerStatusBase.is_loading,
      };
    case "DONG_BO_PHI_KY_TUC_XA_LOAD_SUCCESS":
      return {
        ...state,
        sinhViens: action.payload,
        status: eReducerStatusBase.is_completed,
      };
    case "DONG_BO_PHI_KY_TUC_XA_LOAD_ERRR":
      return {
        ...state,
        sinhViens: [] as IDongBoPhiKyTucXaSinhVien[],
        status: eReducerStatusBase.is_completed,
      };
    case "DONG_BO_PHI_KY_TUC_XA_SYNC_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
        processId: action.payload.process_id,
        isShowProcessing: true,
      };
    case "DONG_BO_PHI_KY_TUC_XA_SYNC_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_saved,
      };
    case "DONG_BO_PHI_KY_TUC_XA_SYNC_ERR":
      return {
        ...state,
        status: eReducerStatusBase.is_saved,
      };
    case "DONG_BO_PHI_KY_TUC_XA_CLOSE_PROCESSING_MODAL":
      return {
        ...state,
        isShowProcessing: false,
      };

    default:
      return state;
  }
};
